import React, { useState, useEffect, useCallback } from 'react';
import { createEditor } from 'slate';
import { Slate, Editable, withReact } from 'slate-react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from "firebase/firestore"; // Firestore-Funktionen importieren
import { db } from "../../firebase/firebase"; // Firestore-Instanz importieren
import { getMarked, getBlock } from './utils/SlateUtilityFunctions.js';
import PageNotAssigned from '../PageNotAssigned'; // Importiere den Modal-Component

const Element = (props) => {
  return getBlock(props);
};

const Leaf = ({ attributes, children, leaf }) => {
  children = getMarked(leaf, children);
  return <span {...attributes}>{children}</span>;
};

function ReadOnlySlatePage(content) {
  const [editor] = useState(() => withReact(createEditor()));
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState([
    {
      type: 'paragraph',
      children: [{ text: 'Lädt...' }],
    },
  ]);

  const renderElement = useCallback((props) => <Element {...props} />, []);

  const renderLeaf = useCallback((props) => {
    return <Leaf {...props} />;
  }, []);

  useEffect(() => {
    const loadPage = async () => {
      try {
        const loadedValue = JSON.parse(content.content); // Parse den Slate-Inhalt
        setValue(
          Array.isArray(loadedValue) && loadedValue.length > 0
            ? loadedValue
            : [{ type: 'paragraph', children: [{ text: '' }] }]
        );
      } catch (err) {
        console.error('Fehler beim Laden:', err);
        setValue([
          {
            type: 'paragraph',
            children: [{ text: 'Fehler beim Laden der Inhalte.' }],
          },
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadPage();
  }, [content]);

  if (loading) {
    return <p>Lädt...</p>;
  }

  return (
    <div>
      <Slate editor={editor} value={value} initialValue={value}>
        <Editable
          readOnly
          placeholder="Keine Inhalte verfügbar."
          renderElement={renderElement}
          renderLeaf={renderLeaf}
        />
      </Slate>
    </div>
  );
}

export default ReadOnlySlatePage;